import { message } from "antd";
import {
  ABOUT_HIGHLIGHTS_UPLOAD_REQUEST,
  ABOUT_HIGHLIGHTS_UPLOAD_SUCCESS,
  ABOUT_HIGHLIGHTS_UPLOAD_FAIL,
  ABOUT_HIGHLIGHTS_FETCH_REQUEST,
  ABOUT_HIGHLIGHTS_FETCH_SUCCESS,
  ABOUT_HIGHLIGHTS_FETCH_FAIL,
  ABOUT_HIGHLIGHTS_DELETE_REQUEST,
  ABOUT_HIGHLIGHTS_DELETE_SUCCESS,
  ABOUT_HIGHLIGHTS_DELETE_FAIL,
} from "../../constants/admin/aboutHighlightsConstants";
import axios from "../../../axiosInstance";

// 🔹 Upload about highlights images
export const uploadAboutHighlights = (images) => async (dispatch) => {
  try {
    dispatch({ type: ABOUT_HIGHLIGHTS_UPLOAD_REQUEST });

    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image);
    });

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const { data } = await axios.post(
      "/api/v1/about-highlights/upload",
      formData,
      config
    );

    if (data?.success === true) {
          dispatch({ type: ABOUT_HIGHLIGHTS_UPLOAD_SUCCESS, payload: data });
          message.success(data?.message || "About highlights images added successfully");
        } else {
          throw new Error(data?.message || "Failed to about highlights images");
        }
  } catch (error) {
    dispatch({
      type: ABOUT_HIGHLIGHTS_UPLOAD_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to about highlights images"
    );
  }
};

// Fetch about highlights images 
export const fetchAboutHighlights = () => async (dispatch) => {
  try {
    dispatch({ type: ABOUT_HIGHLIGHTS_FETCH_REQUEST });

    const { data } = await axios.get("/api/v1/about-highlights/get");
    dispatch({ type: ABOUT_HIGHLIGHTS_FETCH_SUCCESS, payload: data.aboutHighlights });
  } catch (error) {
    dispatch({
      type: ABOUT_HIGHLIGHTS_FETCH_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
  }
};

// 🔹 Delete about highlights image
export const deleteAboutHighlights = (publicId) => async (dispatch) => {
  try {
    dispatch({ type: ABOUT_HIGHLIGHTS_DELETE_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.delete("/api/v1/about-highlights/delete", {
      data: { publicId },
      ...config,
    });
    if (data?.success === true) {
      dispatch({ type: ABOUT_HIGHLIGHTS_DELETE_SUCCESS, payload: data });
      message.success(data?.message || "About highlights image deleted successfully");
    } else {
      throw new Error(data?.message || "Failed to about highlights images");
    }
  } catch (error) {
    dispatch({
      type: ABOUT_HIGHLIGHTS_DELETE_FAIL,
      payload: error.response?.data?.message || "Something went wrong",
    });
    message.error(
      error?.response?.data?.message || "Failed to about highlights images"
    );
  }
};
